<app-frame [overlay]="false" [title]="title" (neadClose)="closeVisitForm()" autocomplete="off">
	<div>
		You have past dues follow-ups. Please address them before we enable the Save functionality.
	</div>
	<app-form-actions-content>
		<form-button (clickOnButton)="goToFollowUp()">Ok</form-button>
		<form-button (clickOnButton)="cancel()" buttonType="warning">Cancel</form-button>
	</app-form-actions-content>
</app-frame>
